import ReportsPrintTable from "../components/ReportsPrint/ReportsPrintTable";
import StartingPageContent from "../components/StartingPage/StartingPageContent";
const ReportsPrintPage = () => {
  return (
    <StartingPageContent pageName="Raport Print">
      <ReportsPrintTable />
    </StartingPageContent>
  );
};

export default ReportsPrintPage;
